
function IssueSkusCtrl($scope, TranslationService, ToastService, $uibModal, MaterialService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.remove = function (index) {
        ctrl.issue.Details.splice(index, 1);
    }

    ctrl.addSku = function ()
    {
        var sku = {
            SkuID: '',
            SkuName: '',
            Quantity: 0,
            PriceUnitID: '',
            IsManual: true
        };
        ctrl.issue.Details.push(sku);
    }

    ctrl.selectItemUN = function (item) {
        setTimeout(function () {
            var detail = ctrl.issue.Details.find(function (detail) {
                return detail.SkuID === item.Key;
            });

            if (detail)
                detail.PriceUnitID = item.UN;

            $scope.$apply();
        }, 300);
    }

    ctrl.findSkuIndex = function (skuID) {
        return ctrl.issue.Details.findIndex(function (sku) {
            return sku.SkuID == skuID;
        });
    };

    ctrl.addSkus = function (skus) {
        console.log('SELECTED ', skus);
        skus.forEach(function (sku) {
            var skuIndex = ctrl.findSkuIndex(sku.SkuID);
            if (skuIndex < 0) {
                var newSku = {
                    SkuID: sku.SkuID,
                    SkuName: sku.SkuName,
                    Quantity: sku.Quantity,
                    PriceUnitID: sku.PriceUnitID	
                };
                if (sku.selected) {
                    ctrl.issue.Details.push(newSku);
                }                
            }
            else {
                if (!sku.selected)
                {
                    ctrl.issue.Details.splice(skuIndex, 1);
                }
            }
        });
    };

    ctrl.selectSkus = function () {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'SPA/helpdesk/selectSkuModal.html' + seedWebApp.buildVersion,
            controller: 'SelectSkuModalController',
            size: 'md',
            resolve: {
                info: function () {
                    return {                        
                        Issue: ctrl.issue,                        
                    }
                },
                //isDanger: false,
            }
        });

        modalInstance.result.then(
            function (skus) {         
                ctrl.addSkus(skus);
            }, function () {
            }
        );
    }

    ctrl.skuSearch = function (query) {
        console.log('skuSearch ' + query);
        return MaterialService.getSkusQuery(query, ctrl.issue.ContactID ? ctrl.issue.ContactID : "")
            .then(function (response) {
                return response.data.map(function (item) {
                    return item;
                });
            })
            .catch(function (err) {
                console.error(err);
            });
    };

    ctrl.selectSku = function (item) {
        console.log('after selectSku ', item);
        if (item && item.SkuID) {
            //$scope.item.ContactID = item.ContactID;
        }
    };
}

IssueSkusCtrl.$inject = ['$scope', 'TranslationService', 'ToastService', '$uibModal', 'MaterialService'];

seedWebApp.component('issueSkus', {
    controller: IssueSkusCtrl,
    controllerAs: 'ctrl',
    bindings: {
        loading: '<',
        issue: '<',        
        stages: '<'
    },
    templateUrl: '/SPA/helpdesk/issueSkus.html' + seedWebApp.buildVersion
});